/**
 * A mixin that provides a method to filter deleted events from a list of events based on a given editing date.
 */
import * as DeletedEventOccurrence from "../../constants/deleted-event-occurrence";

export default {
    methods: {
        /**
         * Filters deleted events from a list of events based on a given editing date.
         * @param {Array} events - The list of events to filter.
         * @param {Date} editingDate - The editing date to use for filtering.
         * @returns {Array} - The filtered list of events.
         */
        filterDeletedEvents(events, editingDate) {
            return _.filter(events, (event) => {
                let available = true;
                _.forEach(event.deleted_events, (deleted_event) => {
                    switch (deleted_event.occurrence) {
                        case DeletedEventOccurrence.SINGLE:
                            available = !window
                                .moment(deleted_event.date_from)
                                .isSame(editingDate);
                            break;
                        case DeletedEventOccurrence.FUTURE_EVENTS:
                            available = window
                                .moment(deleted_event.date_from)
                                .isAfter(editingDate);
                            break;
                    }
                    if (!available) {
                        return false;
                    }
                });
                return available;
            });
        },
    },
};
